import React from 'react';

import {Button} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {Subtitle} from 'src/design/atoms/Typography';

export interface TrackerActiveSessionTransitionProps {
  hasContentRemaining?: boolean;
  onContinue: () => void;
  onComplete: () => void;
}
export const TrackerActiveSessionTransition: React.FC<
  TrackerActiveSessionTransitionProps
> = ({hasContentRemaining, onContinue, onComplete}) => {
  const title =
    hasContentRemaining === true ? 'Ready to continue?' : 'Congratulations!';
  const body =
    hasContentRemaining === true
      ? "If not, you can use the 'Go back' button above to exit the training for now. This does not pause the training timer, and you may fail your training if you leave early."
      : 'You successfully completed your training. Click the continue button below to exit the training.';

  const action = hasContentRemaining === true ? onContinue : onComplete;
  return (
    <Box>
      <Subtitle text={title} />
      <p>{body}</p>
      <Button size="sm" onClick={action}>
        Continue
      </Button>
    </Box>
  );
};
